<template>
  <div>
    <el-collapse v-model="activeNames" style="width: 100%">
      <control-width-and-size-and-zindex v-if="curConfig === 0" :options="options" :ids="ids" />
      <template v-if="curConfig === 0">
        <el-collapse-item title="文字块" name="1">
          <div class="configBox" @click="changeConfig(1, true)">
            <span class="configTitle">文字块</span>
            <span class="configLabel fs12">配置<i class="configIcon icon-portal-arrows-right"></i></span>
          </div>
        </el-collapse-item>
        <el-collapse-item title="排列" name="2">
          <div class="verticallyCenter">
            <span class="fs14 mr16">行数</span>
            <div class="row-set">
              <div class="verticallyCenter el-input">
                <single-input
                  class="mr8"
                  style="width: 104px; flex: 1"
                  :value.sync="rowsLen"
                  :noInputSuffixs="true"
                  :min="minSize"
                  :max="maxSize"
                  :noInputHandle="true"
                  @customBlur="onRowBlur"
                  @keyup="onRowKeyUp"
                  @changeValue="onRowBlur"
                />
                <div class="btn-wrapper">
                  <span
                    :class="rowsLen === minSize ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
                    @click="changeRow(0)"
                  ></span>
                  <span
                    :class="rowsLen === maxSize ? 'disabled num-btn icon-portal-plus' : 'num-btn icon-portal-plus'"
                    @click="changeRow(1)"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="背景" name="3">
          <cx-background infoTips="支持上传图片" :background.sync="background" imgType="10" />
        </el-collapse-item>
        <el-collapse-item title="边框" name="4">
          <div class="setting-item">
            <div class="content">
              <div>
                <div class="content-item verticallyCenter mb12">
                  <el-checkbox v-model="showBorder">显示边框</el-checkbox>
                </div>
                <cx-border
                  v-if="showBorder"
                  :borderWidth.sync="borderWidth"
                  :borderStyle.sync="borderStyle"
                  :borderColor.sync="borderColor"
                  :borderIsThemeColor.sync="borderIsThemeColor"
                />
              </div>
              <div class="content-item mt12">
                <border-radius
                  :borderTypeFlag.sync="borderTypeFlag"
                  :borderRadius.sync="borderRadius"
                  :borderTopLeftRadius.sync="borderTopLeftRadius"
                  :borderTopRightRadius.sync="borderTopRightRadius"
                  :borderBottomRightRadius.sync="borderBottomRightRadius"
                  :borderBottomLeftRadius.sync="borderBottomLeftRadius"
                />
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="边距" name="5">
          <div class="setting-item">
            <div class="content">
              <div class="content-item">
                <cx-padding
                  :paddingTypeFlag.sync="topPaddingTypeFlag"
                  :padding.sync="padding"
                  :paddingTop.sync="paddingTop"
                  :paddingRight.sync="paddingRight"
                  :paddingBottom.sync="paddingBottom"
                  :paddingLeft.sync="paddingLeft"
                />
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="更多" name="6">
          <div class="content">
            <div class="verticallyCenter">
              <slider-and-input
                inputWidth="small"
                inputHeight="small"
                :value.sync="opacity"
                title="透明度"
                :sliderMax="100"
                suffix="%"
              />
            </div>
            <div class="content-item mt16">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('b')"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="boxShadowH"
                :boxShadowV.sync="boxShadowV"
                :boxShadowBlur.sync="boxShadowBlur"
                :boxShadowSpread.sync="boxShadowSpread"
                :boxShadowColor.sync="boxShadowColor"
              />
            </div>
          </div>
        </el-collapse-item>
      </template>
      <template v-if="curConfig === 1">
        <div class="configBackBox" @click="changeConfig(0, false)">
          <i class="configBackIcon icon-portal-arrows-left"></i>
          <span class="configBackTitle">文字块</span>
        </div>
        <width-and-height-size
          :widthVal.sync="textWidth"
          :heightVal.sync="textHeight"
          :widthAuto.sync="widthAuto"
          :heightAuto.sync="heightAuto"
        />
        <el-collapse-item title="文字" name="2">
          <div>
            <text-setting-complex-update
              :fontFamily.sync="fontFamily"
              :fontSize.sync="fontSize"
              :fontWeight.sync="fontWeight"
              :fontStyle.sync="fontStyle"
              :textDecoration.sync="textDecoration"
              :lineHeight.sync="lineHeight"
              :lineHeightType.sync="lineHeightType"
              :letterSpacing.sync="letterSpacing"
              :activeArrangement.sync="activeArrangement"
              :writingMode.sync="writingMode"
              :textAlign.sync="textAlign"
              :activeArrangementOrder.sync="activeArrangementOrder"
              :isThemeColor.sync="textIsThemeColor"
              :colorArr.sync="color"
              :enableVerticalAlign="true"
              :verticalAlign.sync="verticalAlign"
              :showOverflowSetting="true"
              :contentHasLimit.sync="textLimit"
              :contentHasLimitRadio="'字数'"
              :overflowTypes="['字数', '无']"
              :textLimitWords.sync="textLimitCount"
              :options="options"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item title="背景" name="3">
          <div>
            <label class="font14 inlineMiddle mr24">
              支持添加多个，随机分布显示<span @click="addColorControl" class="icon-portal-plus-small right_font"></span>
            </label>
            <div class="verticallyCenter mt16 single_color" v-for="(color, index) in colorList" :key="index">
              <color-picker class="w_208 mt-0" :color="color" @change="changeColor(index, $event)" />
              <div v-if="index !== 0" class="icon_set inlineMiddle" @click="deleteColor(index)">
                <span class="fs16 icon-portal-delete"></span>
              </div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="边框" name="4">
          <el-checkbox v-model="showTextBorder">显示边框</el-checkbox>
          <div>
            <div class="mt16" v-if="showTextBorder">
              <span>边框</span>
              <cx-border
                :borderWidth.sync="textBorderWidth"
                :borderStyle.sync="textBorderStyle"
                :borderColor.sync="textBorderColor"
                :borderIsThemeColor.sync="textBorderIsThemeColor"
              />
            </div>
            <border-radius
              class="mt16"
              :borderTypeFlag.sync="textBorderTypeFlag"
              :borderRadius.sync="textBorderRadius"
              :borderTopLeftRadius.sync="textBorderTopLeftRadius"
              :borderTopRightRadius.sync="textBorderTopRightRadius"
              :borderBottomRightRadius.sync="textBorderBottomRightRadius"
              :borderBottomLeftRadius.sync="textBorderBottomLeftRadius"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item title="边距" name="5">
          <div>
            <cx-padding
              :paddingTypeFlag.sync="textPaddingTypeFlag"
              :padding.sync="textPadding"
              :paddingTop.sync="textPaddingTop"
              :paddingRight.sync="textPaddingRight"
              :paddingBottom.sync="textPaddingBottom"
              :paddingLeft.sync="textPaddingLeft"
            />
          </div>
        </el-collapse-item>
        <el-collapse-item title="更多" name="6">
          <div>
            <div class="verticallyCenter">
              <slider-and-input
                inputWidth="small"
                inputHeight="small"
                :value.sync="textOpacity"
                title="透明度"
                :sliderMax="100"
                suffix="%"
              />
            </div>
            <div class="mt16">
              <div class="checkbox_colorPicker_container">
                <span>阴影</span>
                <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow('textB')"></span>
              </div>
              <box-shadow
                :boxShadowH.sync="textBoxShadowH"
                :boxShadowV.sync="textBoxShadowV"
                :boxShadowBlur.sync="textBoxShadowBlur"
                :boxShadowSpread.sync="textBoxShadowSpread"
                :boxShadowColor.sync="textBoxShadowColor"
              ></box-shadow>
            </div>
          </div>
        </el-collapse-item>
      </template>
      <el-collapse-item v-show="$store.state.states.showPluginSetting && curConfig === 0" title="插件" name="9">
        <div class="setting-item">
          <element-plugin-setting :pluginName="pluginName" :myid="ids"></element-plugin-setting>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import elementPluginSetting from "publicSetting/elementPluginSetting.vue"
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex.vue"
import widthAndHeightSize from "publicSetting/widthAndHeightSize"
import { withMethodsHistoryCombine } from "utils/revork"
export default withMethodsHistoryCombine({
  components: {
    controlWidthAndSizeAndZindex,
    elementPluginSetting,
    widthAndHeightSize
  },
  props: {
    options: Object,
    statusOpened: Boolean,
    styleOpened: Boolean
  },
  data() {
    return {
      activeNames: ["1", "2", "3"],
      curConfig: 0,
      rowsLen: 1,
      minSize: 1,
      maxSize: 50
    }
  },
  watch: {
    "options.rowLen": {
      handler(val) {
        this.rowsLen = val
      },
      immediate: true
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "pluginName", "pluginName", [])
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "pluginName", false)
      }
    },
    rowLen: {
      get() {
        return this.options.rowLen
      },
      set(val) {
        this.$changeOptionsEV(val, "rowLen", false)
      }
    },
    opacity: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "opacity", "opacity", 100)
      },
      set(newVal) {
        newVal !== this.opacity && this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return this.options.background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false)
      }
    },
    activeArrangement() {
      return this.options.textAlign
    },
    textLimitCount: {
      get() {
        return this.options.textLimitCount
      },
      set(val) {
        this.$changeOptionsEV(val, "textLimitCount", false)
      }
    },
    textLimit: {
      get() {
        return this.options.textLimit
      },
      set(val) {
        this.$changeOptionsEV(val, "textLimit", false)
      }
    },
    activeArrangementOrder: {
      get() {
        return {
          _class: "icon-portal-text-down1",
          isActive: this.options.writingMode === "vertical-lr" ? true : false
        }
      },
      set(newVal) {
        let val = newVal ? "vertical-lr" : "horizontal-tb"
        this.$changeOptionsEV(val, "writingMode", false)
      }
    },
    fontFamily: {
      get() {
        return this.options.fontFamily
      },
      set(val) {
        this.$changeOptionsEV(val, "fontFamily", false)
      }
    },
    fontSize: {
      get() {
        return this.options.fontSize
      },
      set(val) {
        this.$changeOptionsEV(val, "fontSize", false)
      }
    },
    fontWeight: {
      get() {
        return this.options.fontWeight
      },
      set(val) {
        this.$changeOptionsEV(val, "fontWeight", false)
      }
    },
    fontColor: {
      get() {
        return this.options.fontColor
      },
      set(val) {
        this.$changeOptionsEV(val, "fontColor", false)
      }
    },
    letterSpacing: {
      get() {
        return this.options.letterSpacing
      },
      set(newVal) {
        this.$changeOptionsEV(`${newVal}`, "letterSpacing", false)
      }
    },
    lineHeight: {
      get() {
        return this.options.lineHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeight", false)
      }
    },
    lineHeightType: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "lineHeightType", "lineHeightType", "px")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "lineHeightType", false)
      }
    },
    fontStyle: {
      get() {
        return this.options.fontStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "fontStyle", false)
      }
    },
    textAlign: {
      get() {
        return this.options.textAlign
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textAlign", false)
      }
    },
    verticalAlign: {
      get() {
        return this.options.verticalAlign || "top"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "verticalAlign", false)
      }
    },
    color: {
      get() {
        return this.options.color
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "color", false)
      }
    },
    textIsThemeColor: {
      get() {
        return this.options.textIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textIsThemeColor", false)
      }
    },
    writingMode: {
      get() {
        return this.options.writingMode
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "writingMode", false)
      }
    },
    textDecoration: {
      get() {
        return this.options.textDecoration
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textDecoration", false)
      }
    },
    bgColor: {
      get() {
        return this.options.bgColor
      },
      set(val) {
        this.$changeOptionsEV(val, "bgColor", false)
      }
    },
    bgIsThemeColor: {
      get() {
        return this.options.bgIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "bgIsThemeColor", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(val) {
        this.$changeOptionsEV(val, "borderColor", false)
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        if (this.options.showBorder === undefined) {
          if (Array.isArray(this.options.borderWidth)) {
            let allZero = true
            for (let i = 0; i < this.options.borderWidth.length; i++) {
              if (this.options.borderWidth[i] !== 0) {
                allZero = false
              }
            }
            if (allZero) {
              showBorder = false
            } else {
              showBorder = true
            }
          } else {
            if (this.options.borderWidth) {
              showBorder = true
            } else {
              showBorder = false
            }
          }
        } else {
          showBorder = this.options.showBorder
        }
        return showBorder
      },
      set(newVal) {
        if (newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showBorder", false)
        }
      }
    },
    borderWidth: {
      get() {
        return this.options.borderWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "borderWidth", false)
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(val) {
        this.$changeOptionsEV(val, "borderStyle", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.options.borderIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "borderIsThemeColor", false)
      }
    },
    showTextBorder: {
      get() {
        return this.options.showTextBorder
      },
      set(newVal) {
        if (newVal && !this.textBorderWidth) {
          this.$changeOptionsEV([1, newVal], ["textBorderWidth", "showTextBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showTextBorder", false)
        }
      }
    },
    textBorderColor: {
      get() {
        return this.options.textBorderColor
      },
      set(val) {
        this.$changeOptionsEV(val, "textBorderColor", false)
      }
    },
    textBorderWidth: {
      get() {
        return this.options.textBorderWidth
      },
      set(val) {
        this.$changeOptionsEV(val, "textBorderWidth", false)
      }
    },
    textBorderStyle: {
      get() {
        return this.options.textBorderStyle
      },
      set(val) {
        this.$changeOptionsEV(val, "textBorderStyle", false)
      }
    },
    textBorderIsThemeColor: {
      get() {
        return this.options.textBorderIsThemeColor
      },
      set(val) {
        this.$changeOptionsEV(val, "textBorderIsThemeColor", false)
      }
    },
    textBorderTypeFlag: {
      get() {
        return this.options.textBorderTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textBorderTypeFlag", false)
      }
    },
    textBorderRadius: {
      get() {
        return Number(this.options.textBorderRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal, newVal],
          [
            "textBorderRadius",
            "textBorderTopLeftRadius",
            "textBorderTopRightRadius",
            "textBorderBottomRightRadius",
            "textBorderBottomLeftRadius"
          ],
          false
        )
      }
    },
    textBorderTopLeftRadius: {
      get() {
        return Number(this.options.textBorderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textBorderTopLeftRadius", false)
      }
    },
    textBorderTopRightRadius: {
      get() {
        return Number(this.options.textBorderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textBorderTopRightRadius", false)
      }
    },
    textBorderBottomRightRadius: {
      get() {
        return Number(this.options.textBorderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textBorderBottomRightRadius", false)
      }
    },
    textBorderBottomLeftRadius: {
      get() {
        return Number(this.options.textBorderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textBorderBottomLeftRadius", false)
      }
    },
    // 边距
    textPaddingTypeFlag: {
      get() {
        return this.options.textPaddingTypeFlag
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textPaddingTypeFlag", false)
      }
    },
    textPadding: {
      get() {
        return this.options.textPadding
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textPadding", false)
      }
    },
    textPaddingTop: {
      get() {
        return this.options.textPaddingTop
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textPaddingTop", false)
      }
    },
    textPaddingRight: {
      get() {
        return this.options.textPaddingRight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textPaddingRight", false)
      }
    },
    textPaddingLeft: {
      get() {
        return this.options.textPaddingLeft
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textPaddingLeft", false)
      }
    },
    textPaddingBottom: {
      get() {
        return this.options.textPaddingBottom
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textPaddingBottom", false)
      }
    },
    textBoxShadowColor: {
      get() {
        return this.options.textBoxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textBoxShadowColor", false)
      }
    },
    textBoxShadowH: {
      get() {
        return this.options.textBoxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textBoxShadowH", false)
      }
    },
    textBoxShadowV: {
      get() {
        return this.options.textBoxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textBoxShadowV", false)
      }
    },
    textBoxShadowBlur: {
      get() {
        return this.options.textBoxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textBoxShadowBlur", false)
      }
    },
    textBoxShadowSpread: {
      get() {
        return this.options.textBoxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textBoxShadowSpread", false)
      }
    },
    textOpacity: {
      get() {
        return this.options.textOpacity
      },
      set(val) {
        this.$changeOptionsEV(val, "textOpacity", false)
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (
            ((this.borderTopLeftRadius === this.borderTopRightRadius) === this.borderBottomLeftRadius) ===
            this.borderBottomRightRadius
          ) {
            defaultType = 2
          }
        }
        return this.options.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    borderRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(
          [newVal, newVal, newVal, newVal],
          ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderTopLeftRadius: {
      get() {
        return Number(this.options.borderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return Number(this.options.borderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return Number(this.options.borderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.boxShadowColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.boxShadowH
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.boxShadowV
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.boxShadowBlur
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.boxShadowSpread
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    widthAuto: {
      get() {
        return this.options.widthAuto
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "widthAuto", false)
      }
    },
    heightAuto: {
      get() {
        return this.options.heightAuto
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "heightAuto", false)
      }
    },
    textWidth: {
      get() {
        return this.options.textWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textWidth", false)
      }
    },
    textHeight: {
      get() {
        return this.options.textHeight
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "textHeight", false)
      }
    },
    padding: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "padding", "padding", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    topPaddingTypeFlag: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "topPaddingTypeFlag", "topPaddingTypeFlag", 1)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "topPaddingTypeFlag", false)
      }
    },
    paddingTop: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingTop", "paddingTop", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingRight", "paddingRight", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingLeft", "paddingLeft", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "paddingBottom", "paddingBottom", 0)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    colorList: {
      get() {
        return this.options.colorList || []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "colorList", false)
      }
    }
  },
  mounted() {
    this.$emit("update:statusOpened", false)
    this.$emit("update:styleOpened", true)
    this.$emit("onHideHeader", false)
  },
  methods: {
    addBoxshadow(prefix) {
      if (!Array.isArray(this[`${prefix}oxShadowH`])) {
        this[`${prefix}oxShadowH`] = [this[`${prefix}oxShadowH`]]
        this[`${prefix}oxShadowV`] = [this[`${prefix}oxShadowV`]]
        this[`${prefix}oxShadowBlur`] = [this[`${prefix}oxShadowBlur`]]
        this[`${prefix}oxShadowSpread`] = [this[`${prefix}oxShadowSpread`]]
        this[`${prefix}oxShadowColor`] = [this[`${prefix}oxShadowColor`]]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this[`${prefix}oxShadowH`]))
      let boxShadowV = JSON.parse(JSON.stringify(this[`${prefix}oxShadowV`]))
      let boxShadowBlur = JSON.parse(JSON.stringify(this[`${prefix}oxShadowBlur`]))
      let boxShadowSpread = JSON.parse(JSON.stringify(this[`${prefix}oxShadowSpread`]))
      let boxShadowColor = JSON.parse(JSON.stringify(this[`${prefix}oxShadowColor`]))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this[`${prefix}oxShadowH`] = boxShadowH
      this[`${prefix}oxShadowV`] = boxShadowV
      this[`${prefix}oxShadowBlur`] = boxShadowBlur
      this[`${prefix}oxShadowSpread`] = boxShadowSpread
      this[`${prefix}oxShadowColor`] = boxShadowColor
    },
    changeConfig(val, flag) {
      this.curConfig = val
      this.$emit("update:statusOpened", flag)
      this.$emit("update:styleOpened", !flag)
      this.$emit("onHideHeader", flag)
    },
    onRowBlur() {
      this.rowLen = this.rowsLen
    },
    onRowKeyUp(e) {
      if (e.keyCode === 13) {
        e.target.blur()
        this.onRowBlur()
      }
    },
    changeRow(flag) {
      if (flag === 1) {
        if (this.rowsLen < this.maxSize) {
          this.rowsLen++
          this.onRowBlur()
        }
      } else {
        if (this.rowsLen > this.minSize) {
          this.rowsLen--
          this.onRowBlur()
        }
      }
    },
    addColorControl() {
      const list = [...this.colorList]
      this.request_prefix === "bigScreen" ? list.push("#FFFFFF") : list.push("#3D82F2")
      this.colorList = [...list]
    },
    deleteColor(index) {
      const list = [...this.colorList]
      list.splice(index, 1)
      this.colorList = [...list]
    },
    changeColor(index, newColor) {
      const list = [...this.colorList]
      list[index] = newColor
      this.colorList = [...list]
    }
  }
})
</script>

<style lang="scss" scoped>
.configBox {
  height: 32px;
  padding: 4px 4px 4px 12px;
  border-radius: 4px;
  background: var(--inputBg);
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:hover {
    background: var(--inputNuberHoverThemeBgColor);
  }
  .configTitle {
    font-size: 13px;
    font-weight: 600;
    color: var(--textColor);
  }
  .configLabel {
    color: var(--thirdTextColor);
    display: flex;
  }
  .configIcon {
    font-size: 20px;
  }
  &:hover {
    cursor: pointer;
  }
}
.configBackBox {
  height: 38px;
  padding-left: 12px;
  display: flex;
  gap: 4px;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
  .configBackIcon {
    font-size: 24px;
  }
  .configBackTitle {
    font-size: 14px;
    font-weight: 600;
    color: var(--textColor);
  }
}
.row-set {
  flex: 1;
  input {
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 0 10px;
    box-sizing: border-box;
    margin-right: 16px;
  }
  .btn-wrapper {
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 6px 0;
    font-size: 0;
    flex: 1;
    .num-btn {
      display: inline-block;
      width: 50%;
      text-align: center;
      line-height: 20px;
      font-size: 13px;
      cursor: pointer;
      &:not(:last-child) {
        border-right: 1px solid var(--sliderBackGround);
      }
      &:not(.disabled):hover {
        color: var(--themeColor);
      }
      &.disabled {
        color: var(--borderColorSeven);
        cursor: not-allowed;
      }
    }
  }
}
.right_font {
  position: absolute;
  font-size: 16px;
  right: 20px;
  text-align: right;
  color: var(--themeColor);
  margin-top: 2px;
  &:hover {
    cursor: pointer;
  }
}
.single_color {
  .icon_set {
    font-size: 14px;
    color: var(--thirdTextColor);
    line-height: 1;
    cursor: pointer;
    margin-left: 4px;
  }
}
.w_208 {
  width: 208px;
}
</style>
